import { UserManageWorkspace } from './UserManageWorkspace';
// 손짠 머리 → 정본 PageHeader · 경로 · 범위 칩(2026-10-17 · web 레인 W7a — lib/page-crumbs.ts)
import { PageHeader } from '../../components/shared';
import { crumbsFor, scopeFor } from '../../lib/page-crumbs';

/**
 * 근태 › 사용자 관리 — 2026-08-25.
 *
 * 사용자 지시로 **관리 콘솔(8444)의 사용자 관리 화면을 근태 하위 메뉴에도 둔다.** 콘솔 쪽은
 * 그대로 남는다(옮긴 것이 아니라 복사다). 화면 본체는 `UserManageWorkspace` 가 그대로 이고,
 * 이 파일은 8443 의 다른 근태 관리 화면(`.hra`)과 같은 제목 줄·여백만 씌운다.
 *
 * 권한: 라우트의 `RoleGuard(['ADMIN','SYSTEM_ADMIN'])` 가 먼저 가리고, 서버가 최종 판정한다
 * (chat-server `admin-org.routes.ts` · `user-admin.routes.ts` 의 requiredRoles).
 */
export function UserManagePage(): JSX.Element {
  return (
    <div className="hru">
      <PageHeader
        breadcrumb={crumbsFor('/erp/hr/users', { leaf: '사용자 관리' })}
        scope={scopeFor('/erp/hr/users')}
        title="사용자 관리"
        description="부서·팀과 계정을 한 화면에서 · 관리 콘솔의 같은 화면과 같은 서버를 봅니다"
      />
      <UserManageWorkspace />
    </div>
  );
}
